/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2022. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import BaseApiService from './base.api-service';

const ENDPOINTS = {
  AVAILABLE_VERSIONS: `/nerve/update/cloud/available-versions`,
  CURRENT_VERSION: `/nerve/update/cloud/current-version`,
  INCOMPATIBLE_COMPATIBLE_NODES_FOR_VERSION: `/nerve/update/cloud/incompatible-nodes`,
  LIST_CONNECTION_MANAGER_FILES: '/nerve/connection-manager/files',
  DOWNLOAD_CONNECTION_MANAGER_FILE: '/nerve/connection-manager/download',
};
class AvailableUpdatesService extends BaseApiService {
  getAvailableVersions() {
    return this.get(ENDPOINTS.AVAILABLE_VERSIONS, {
      authRequired: true,
    });
  }

  getCurrentVersions() {
    return this.get(ENDPOINTS.CURRENT_VERSION, {
      authRequired: true,
    });
  }

  getIncompatibleCompatibleNodesForVersion(version) {
    return this.get(`${ENDPOINTS.INCOMPATIBLE_COMPATIBLE_NODES_FOR_VERSION}/${version}`, {
      authRequired: true,
    });
  }

  getConnectionManagerFiles() {
    return this.get(ENDPOINTS.LIST_CONNECTION_MANAGER_FILES, {
      authRequired: true,
    });
  }

  downloadConnectionManagerFile(platform) {
    return this.get(`${ENDPOINTS.DOWNLOAD_CONNECTION_MANAGER_FILE}/${platform}`, {
      authRequired: true,
      responseType: 'blob',
    });
  }
}

export default new AvailableUpdatesService();
